export default {
  brand: {
    primary: '#232f3e',
    secondary: '#ff9900',
    tertiary: '#eb8d00',
    quaternary: '#000000',
  },
};
